export default "__VITE_ASSET__Cx5hEZlN__"